<template>
  <div>
    <CCard class="bg-style2 mb-3">
      <CCardHeader  class="bg-gradient-dark text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
        <label class="font-weight-bold mt-1">  {{ objs.title.filter(item => { return (item.key === lang)})[0].value }} </label>
      </CCardHeader>
      <CCardBody >
        <CRow class="mb-3">
          <CCol col="2" class="mt-2"> <label class="required font-weight-bold"> วิธีการพัฒนา </label> </CCol>
          <CCol col="10" class="pl-2 pr-3">
            <Multiselect
                class="os ml-1 "
                v-model="select.method"
                :options="option.method"
                label="label"
                track-by="value"
                :multiple="false"
                :search="true"
                :disabled="disabled"
            >
            </Multiselect>
          </CCol>
        </CRow>

        <CRow class="mb-3">
          <CCol col="2" class="mt-2"> <label class="required font-weight-bold"> รายละเอียด </label> </CCol>
          <CCol col="10" class="pl-2 pr-3">
            <QEditor :content="objs" jkey="methods" :disabled="disabled" />
          </CCol>
        </CRow>

        <CRow class="mb-3">
          <CCol col="2" class="mt-2"> <label class="required font-weight-bold"> ระยะเวลา </label> </CCol>
          <CCol col="10" class="pl-2 pr-3">
            <CRow>
              <CCol>
<!--                {{new moment(objs.period.startDate).format('YYYY-MM-DD')}}-->
                <CInput :disabled="disabled" type="date" v-model="objs.period.startDate" :min="new moment().format('YYYY-MM-DD')"></CInput>
              </CCol>
              <label>-</label>
              <CCol>
                <CInput :disabled="disabled" type="date" v-model="objs.period.endDate" :min="new moment(objs.period.startDate).add('days',+1).format('YYYY-MM-DD')"></CInput>
              </CCol>
            </CRow>
          </CCol>
        </CRow>

        <CRow >
          <CCol col="12" class="mt-2"> <label class="required font-weight-bold"> ความต้องการ การสนับสนุน </label> </CCol>
        </CRow>
        <CDropdownDivider/>

        <CRow class="mb-3">
          <CCol col="2" class="mt-2"> <label class="required font-weight-bold"> {{ $t('faculty') }} </label> </CCol>
          <CCol col="10" class="pl-2 pr-3">
            <Multiselect
                class="os ml-1 "
                v-model="select.faculty"
                :options="option.faculty"
                label="label"
                track-by="value"
                :multiple="false"
                :search="true"
                :disabled="disabled"
            >
            </Multiselect>
          </CCol>
        </CRow>

        <CRow class="mb-3">
          <CCol col="2" class="mt-2"> <label class="required font-weight-bold"> {{ $t('budget')}} </label> </CCol>
          <CCol col="10" class="pl-2 pr-3">
            <CRow>
              <CCol>
                <CInput :disabled="disabled" type="number" :horizontal="{ input:'col-12 text-right' }" v-model="objs.supports.budget"></CInput>
              </CCol>
            </CRow>
          </CCol>
        </CRow>


        <CRow >
          <CCol col="12" class="mt-2"> <label class="required font-weight-bold"> สิ่งที่ได้เรียนรู้จากการพัฒนา </label> </CCol>
        </CRow>
        <CDropdownDivider/>


        <CRow class="mb-3">
          <CCol col="2" class="mt-2"> <label class="required font-weight-bold"> รายละเอียด </label> </CCol>
          <CCol col="10" class="pl-2 pr-3">
            <QEditor  :content="objs" jkey="learned" :disabled="disabled"/>
          </CCol>
        </CRow>

<!--        {{ this.$store.getters["personal/profile"]._id  }}-->

<!--        {{ this.$store.getters['idp/idp'].assessor._id }}-->
<!--{{this.$store.getters['idp/idp'].status.at(-1)._id }}-->
<!--        <div v-if="this.$store.getters['personal/profile']._id === this.$store.getters['idp/idp'].assessor._id  ">-->
          <CRow >
            <CCol col="12" class="mt-2"> <label class="required font-weight-bold"> การประเมินผลลัพธ์ </label> </CCol>
          </CRow>
          <CDropdownDivider/>

          <CRow class="mb-3">
            <CCol col="2" class="mt-2"> <label class="required font-weight-bold"> ผู้ประเมิน </label> </CCol>
            <CCol class="pl-2 pr-3 mt-2">
              <label  >{{ this.$store.getters['idp/idp'].assessor.accounts.accounts.userinfo.prefix.filter(obj => { return (obj.key === lang) })[0].value }} {{ this.$store.getters['idp/idp'].assessor.accounts.accounts.userinfo.firstName.filter(obj => { return (obj.key === lang) })[0].value }}  {{ this.$store.getters['idp/idp'].assessor.accounts.accounts.userinfo.lastName.filter(obj => { return (obj.key === lang) })[0].value }} </label>
            </CCol>
            <CSwitch :disabled="disabled" size="lg" class="mt-1 mr-3" color="success" variant="opposite" shape="pill" v-model="objs.status" v-bind="labelIcon" :checked="objs.status" @update:checked="(val) => objs.status = val "/>

          </CRow>

          <CRow class="mb-3">
            <CCol col="2" class="mt-2"> <label class="required font-weight-bold"> ข้อเสนอแนะ </label> </CCol>
            <CCol col="10" class="pl-2 pr-3">
              <QEditor :content="objs" jkey="suggestions" :disabled="disabled"/>
            </CCol>
          </CRow>
<!--        </div>-->


        <CRow>
          <CCol class="text-right">

<!--            <CButton class="ml-2" size="sm" color="success" shape="pill" variant="outline" >-->
<!--              <span class="font-weight-bold pr-2 pl-2"><CIcon name="cil-paper-plane" class="mr-1" /> <span class="mt-2">SEND</span> </span>-->
<!--            </CButton>-->

            <CButton v-if="this.$store.getters['idp/idp'].isTalent" class="ml-2" size="sm" color="danger" shape="pill" variant="outline" @click="onRemove" >
              <span class="font-weight-bold pr-2 pl-2"><CIcon name="cil-trash" class="mr-1" />  <span class="mt-2">DELETE</span> </span>
            </CButton>

          </CCol>
        </CRow>

      </CCardBody>
    </CCard>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import Multiselect from 'vue-multiselect'
import QEditor from "@/projects/components/Util/QEditor.vue";
import moment from "moment";

export default {
  name: 'IDPFrom',
  components: {QEditor, Multiselect },
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Individual Development Plan'
    },
    objs: {
      type: Object,
      default() {
        return null
      }
    },

    disabled: {
      type: Boolean,
      default: false
    },
  },

  data: function () {
    return {
      collapseDuration: 0,
      select: {
        method: "",
        faculty:""
      },

      option: {
        method: [],
        faculty: []
      },

      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      budget:0,
      state:false,



      // objsFrom: {
      //   code            : 0,
      //   methods         : null,
      //   period          : {
      //     startDate       : null,
      //     endDate         : null,
      //   },
      //   supports         : {
      //     faculty         : null,
      //     budget          : null,
      //   },
      //   learned         : null,
      //   suggestions     : null,
      //   status          : null,
      // }

    }
  },

  mounted() {
    this.syncSelections();
  },

  created() {
    // check objs
    // this.objsFrom.code = this.objs.code;
    // this.objsFrom.methods = this.objs.methods;
    // this.objsFrom.period = this.objs.period;
    // this.objsFrom.supports = this.objs.supports;
    // this.objsFrom.learned = this.objs.learned;
    // this.objsFrom.suggestions = this.objs.suggestions;
    // this.objsFrom.status = this.objs.status;

    this.objs.period.startDate = (this.objs.period.startDate != null)?moment(this.objs.period.startDate).format('YYYY-MM-DD'):null;
    this.objs.period.endDate =  (this.objs.period.endDate != null)?moment(this.objs.period.endDate).format('YYYY-MM-DD'):null;
  },

  beforeDestroy() {
  },


  methods: {
    optionId(value) {
      if (!value) {
        return "";
      }

      if (typeof value === "string") {
        return value;
      }

      return (value.value || value._id || "").toString();
    },

    sameOption(a, b) {
      return this.optionId(a) === this.optionId(b) && ((a || {}).label || "") === ((b || {}).label || "");
    },

    findSelectedOption(options, id) {
      const targetId = this.optionId(id);

      if (!targetId || !Array.isArray(options)) {
        return null;
      }

      return options.find((item) => this.optionId(item) === targetId) || null;
    },

    syncSelectedMethod() {
      const selectedMethod = this.findSelectedOption(this.option.method, this.objs && this.objs.code);

      if (selectedMethod && !this.sameOption(this.select.method, selectedMethod)) {
        this.select.method = selectedMethod;
      }
    },

    syncSelectedFaculty() {
      const selectedFaculty = this.findSelectedOption(this.option.faculty, this.objs && this.objs.supports && this.objs.supports.faculty);

      if (selectedFaculty && !this.sameOption(this.select.faculty, selectedFaculty)) {
        this.select.faculty = selectedFaculty;
      }
    },

    syncSelections() {
      this.syncSelectedMethod();
      this.syncSelectedFaculty();
    },

    toggleDetails (item) {
      item._toggled = !item._toggled
      this.collapseDuration = 300
      this.$nextTick(() => { this.collapseDuration = 0})
    },


    onRemove(){
      this.$emit("remove", this.objs);
    },

  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
      agency: 'agency/item',
      method: "idp/method"
    })
  },

  watch: {
    lang(value){

      var lang = this.$store.getters['setting/lang']
      var data = {};
      data.label = "-"
      data.value = "000000000000000000000000"
      this.option.faculty =  [ data,...this.$store.getters['agency/item'].map(objs => ({ label: objs.title.filter(title => { if (title.key == lang) { return title } })[0].value, value:objs._id }))];
      this.option.method =  [ data,...this.$store.getters['idp/method'].map(objs => ({ label: objs.title.filter(title => { if (title.key == lang) { return title } })[0].value, value:objs._id }))];
      this.syncSelections();
    },
    // ['objsFrom.methods'](value){
    //   console.log(value)
    //   this.objs.methods = value
    // }
    agency: function (value) {

      var lang = this.$store.getters['setting/lang'];
      var data = {};
      data.label = "-";
      data.value = "000000000000000000000000";
      this.option.faculty =  [ data,...value.map(objs => ({ label: objs.title.filter(title => { if (title.key === lang) { return title } })[0].value, value:objs._id }))];

      this.syncSelectedFaculty();
    },

    method: function (value) {

      var lang = this.$store.getters['setting/lang'];
      var data = {};
      data.label = "-";
      data.value = "000000000000000000000000";
      this.option.method =  [ data,...value.map(objs => ({ label: objs.title.filter(title => { if (title.key == lang) { return title } })[0].value, value:objs._id }))];

      this.syncSelectedMethod();
    },

    ['objs.code']: function () {
      this.syncSelectedMethod();
    },

    ['objs.supports.faculty']: function () {
      this.syncSelectedFaculty();
    },

    ['select.method']: function(value){
      // this.objs.code = value.value;
      if(value != undefined && value != null){
        this.objs.code = this.optionId(value);
      }
    },

    ['select.faculty']: function(value){
      if(value != undefined && value != null){
        this.objs.supports.faculty = this.optionId(value);
      }
    },


  }
}
</script>
<style>
.text-right > input[type="number"] {
  text-align: right;
}
.c-switch-input + .c-switch-slider {
  background-color: inherit;
  border-color: #fc1515;
}
.c-switch-input + .c-switch-slider::after {
  color: #fc1515;
}
.c-switch-input + .c-switch-slider::before {
  background-color: #fc1515;
  border-color: #fc1515;
}
</style>
